// extracted by mini-css-extract-plugin
export var alignLeft = "J_rd d_fp d_bG d_dv";
export var alignCenter = "J_bP d_fq d_bD d_dw";
export var alignRight = "J_rf d_fr d_bH d_dx";
export var verticalSolidComponent = "J_v7";
export var compContent = "J_v2 d_r";
export var normal = "J_v8 d_Z d_cb";
export var reverse = "J_v9 d_Z d_bK";
export var last = "J_v3";
export var empty = "J_wb d_r";
export var empty2 = "J_wc d_bw";
export var borderRight = "J_wd d_b8 d_c1";
export var borderLeft = "J_wf d_b9 d_c1";